import {
    GET_USER_LOAD_FILE_STATUS
} from '../../actions/api';

const initialState = {
    [GET_USER_LOAD_FILE_STATUS] : {
        GET : false
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_LOAD_FILE_STATUS: {
            const newState = {...state};
            newState[action.type] = action.payload[action.type];
            return newState;
        }
        default:
            return state;
    }
};
